import { render, staticRenderFns } from "./MbLinkMatchModal.vue?vue&type=template&id=b522e81a"
import script from "./MbLinkMatchModal.vue?vue&type=script&lang=js"
export * from "./MbLinkMatchModal.vue?vue&type=script&lang=js"
import style0 from "./MbLinkMatchModal.vue?vue&type=style&index=0&id=b522e81a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports